import React, { useEffect } from 'react';
import { ItineraryTypes } from '../types';
import classNames from 'classnames';

/**
 * Returns a string of FAs formatted into <name>: <value> pairs joined by a comma
 */
export const flexibleAttributesFormatter = (fa: ItineraryTypes['ItineraryItem']['flexibleAttributes']) => {
  return (fa || []).map(f => `${f.name}: ${f.value}`).join(', ');
};
